export default "/images/4a9cc52e9c245e8215fbc527fcb75cb5.avif";